$(document).ready(function () {
    /* Expand content on when "Read More" is clicked on the About page. */
    $('#about-content .read-more').on('click', function (event) {
        event.preventDefault();
        $(this).hide();
        $(this).closest('section').find('.teaser').css('height', 'auto');
        $(this).closest('section').find('.show-less').css('display', 'block');
    });

    /* Collapse content when "Show Less" is clicked on the About page. */
    $('#about-content .show-less').on('click', function (event) {
        event.preventDefault();
        $(this).hide();
        $(this).closest('section').find('.teaser').css('height', '60px');
        $(this).closest('section').find('.read-more').css('display', 'block');
    });
});
/*
 * Initializes common UI event listeners and helps massage some of the UI as
 * necessary.
 *
 * @author Jonathon McDonald <jonathon@agencyfusion.com>
 * @author Rachel Wolthuis <rachel@agencyfusion.com>
 * clientid a861b5a800d64401883f2ffe0be744dc
 * accessToken 299189746.a861b5a.356ed350cebb486ca2e9054fad0ccd6d
 */

$(document).ready(function () {
    var originalWidth = 1100;
    var originalHeight = 709;
    var screenWidth = $(window).width();

    /*
    // Resize Bootstrap Carousel items.
    function resize() {
        var newHeight = (originalHeight / originalWidth) * screenWidth;
        //This will only set this._originalHeight once
        $(this).css('height', newHeight);
    }

    $('#vimeo-player').each(resize);

    // If the document resizes, resize the player.
    $(document).resize(function () {
        $('#vimeo-player').each(resize);
    });
    */

    function indentDots() {
        var flush = (screenWidth - 960) / 2 + 45;
        //This will only set this._originalHeight once
        $(this).css('left', flush);
    }

    /* Indent the Carousel controls if the screen is sufficiently wide. */
    if (screenWidth > 960) {
        $('.carousel-indicators').each(indentDots);
    }

    /* Remove default form text on focus. */
    $('.emptytext').focus(function () {
        if ($(this).val() == $(this)[0].defaultValue) {
            $(this).val('');
        }
    });

    /* Replace default form text on loss of focus. */
    $('.emptytext').blur(function () {
        if ($(this).val() == '') {
            $(this).val($(this)[0].defaultValue);
        }
    });

    $('.collection-sidebar a').on('click', function (e) {
        $(this).parent('li').toggleClass('target');
    });

    $('#mobile-products-carousel')
        .hammer()
        .on('swipeleft', function () {
            $(this).carousel('next');
        });
    $('#mobile-products-carousel')
        .hammer()
        .on('swiperight', function () {
            $(this).carousel('prev');
        });

    $('#home-carousel')
        .hammer()
        .on('swipeleft', function () {
            $(this).carousel('next');
        });
    $('#home-carousel')
        .hammer()
        .on('swiperight', function () {
            $(this).carousel('prev');
        });

    $('#home-carousel').carousel({
        interval: 4000,
    });

    var $colorTarget = $('[data-color-target]');
    $('a.swatch').on('mouseenter', function () {
        var $this = $(this);

        console.log('Swatch mouseenter', $this, $this.attr('title'));
        $colorTarget.text($this.attr('title'));
    });
    $('a.swatch').on('mouseleave', function () {
        console.log('Swatch mouseenter');
        $colorTarget.text($colorTarget.data('color-default'));
    });

    $('#blog-expand-filter').click(function () {
        if ($(this).html() == '+') {
            $(this).html('&ndash;');
        } else {
            $(this).html('+');
        }

        $('.journal__filter-list').toggleClass('hidden');
    });
});

$(window).load(function () {
    if ($('#shopping-bag').length > 0) {
        $.getJSON('/cart.js', function (cart) {
            if (cart.item_count > 0) {
                var cartItems = '<ul>';
                $.each(cart.items, function (index, item) {
                    if (item.product_description.toLowerCase().indexOf('final sale') >= 0) {
                        //$("span#" + item.variant_id).append(" <font color='red'>FINAL SALE</font>");

                        $('#shopping-bag div#' + item.variant_id).html(" <font color='red'>FINAL SALE</font>");
                        //alert($('#shopping-bag div#' + item.variant_id).text());
                    } else if (item.product_description.toLowerCase().indexOf('store credit') >= 0) {
                        //$("span#" + item.variant_id).append(" <font color='red'>STORE CREDIT ONLY</font>");
                        $('#shopping-bag div#' + item.variant_id).html(" <font color='red'>STORE CREDIT ONLY</font>");
                        // alert($('#shopping-bag div#' + item.variant_id).text());
                    }
                    cartItems += '<li>' + item.title + ' x ' + item.quantity + '</li>';
                });
                cartItems += '</ul>';

                $('#cart-items').html(cartItems);
            } else {
                $('#cart-items').html('Your cart is empty.');
            }
        });
    }
});

/*
$(window).load(function () {
    //giftwrap hiding 1 2 2024
    $('.trGiftWrap').hide();
    if ($(".cart-link p:contains('Gift Wrapping')").length > 0) {
        $('.trGiftWrap').hide();
    }
});
*/

function addGift() {
    jQuery.post('/cart/add.js', {
        quantity: 1,
        id: 39594668785744,
    });

    setTimeout(function () {
        location.reload();
    }, 900);
}

(function ($) {
    /**
     * Creates a CartRowItem view that is tied to an existing DOM element.
     */
    var bindCartItem = function (item) {
        var model = new App.Models.Product(item),
            id = parseInt(model.get('product_id')),
            $el = $('[data-action="' + id + '"]'),
            view = new App.Views.CartRowItem({
                el: $el,
                model: model,
            });

        App.ActiveViews.CartRowItems.push(view);
    };

    /**
     * Loops through the cart and constructs CartRowItems.
     */
    var cartItems = function () {
        App.ActiveViews.CartRowItems = [];
        var foundProducts = App.ActiveModels.Cart.get('items') || [];

        _.each(foundProducts, bindCartItem);
    };

    $(document).ready(cartItems);
})(jQuery);

$(document).on('cart.requestComplete', function (event, cart) {
    $('#product-count').html(cart.item_count);
});

document.addEventListener('DOMContentLoaded', function (event) {
    // Global variables defined in layout/theme.liquid
    CartJS.init(cartJson, {
        currency: window.shop.currency,
        moneyFormat: window.shop.moneyFormat,
        moneyWithCurrencyFormat: window.shop.moneyWithCurrencyFormat,
    });

    $(window).load(function () {
        $('#shopping-bag').show();
    });

    $('#purchase, #cart-link, .nosto-atc:enabled').click(function (event) {
        event.preventDefault();
        $('.sliding-cart').addClass('active');
        $('body').addClass('sliding-cart-displayed');
    });

    $('.sliding-cart-background').click(function () {
        $('.sliding-cart').removeClass('active');
        $('body').removeClass('sliding-cart-displayed');
    });

    $('.sliding-cart-background, .sliding-cart-table-container').css('height', window.innerHeight);

    $(window).resize(function () {
        $('.sliding-cart-background, .sliding-cart-table-container').css('height', window.innerHeight);
    });

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const tag = urlParams.get('tag');
    const tagsHTML = document.querySelectorAll('.current-tag');

    if (tag) {
        tagsHTML.forEach((tagHTML) => {
            const currentTagLink = tagHTML.querySelector('a');
            currentTagLink.innerHTML = tag.replace('_', ' ');
            currentTagLink.setAttribute('href', `/collections/{$cartCollectionHandle}/${tag.replace('_', '-')}`);
            tagHTML.style.display = 'block';
        });
    }
});

/**
 * This handles the following:
 *
 * 1.  Navigation roll over for both the shop and collection
 * 2.  Product zoom
 * 3.  Product/collection share
 * 4.  Iterating through photos
 * 5.  Adjusts height of .product-details div if needed based on largest p
 * 6.  Trim to see more details on product page
 *
 * Product/collection navigation should be similar to:
 *  <a link data-tag="Shirt" data-collection></a> <li data-tags="Shirt, Suit, polyester" />
 * Namespace singleProductHelpers
 *
 * @author Jonathon McDonald <jonathon@agencyfusion.com>
 */
var singleProductHelpers;
singleProductHelpers = {};
singleProductHelpers.collectionTimeout = null;
singleProductHelpers.productHeight = 0;
singleProductHelpers.height = 0;
singleProductHelpers.isZoomOn = false;
singleProductHelpers.shopTimeout = null;
singleProductHelpers.prodImgHeight = 0;
singleProductHelpers.totalInTag = 0;
singleProductHelpers.sleepTimeout = null;
singleProductHelpers.rtwTimeout = null;
singleProductHelpers.swimTimeout = null;
singleProductHelpers.saleTimeout = null;
singleProductHelpers.aboutTimeout = null;
singleProductHelpers.lookbookTimeout = null;
window.App.singleProductHelpers = singleProductHelpers;

/**
 * Trims a description to the first paragraph,
 * and appends a small link to toggle
 * the rest of the description.
 *
 * isShown is optional
 */
singleProductHelpers.toggleDescription = function (selector, isShown) {
    console.log('singleProductHelpers', 'toggleDescription');

    counter = 0;
    if (selector === null) {
        return;
    }

    if (isShown === null) {
        isShown = false;
    }

    var pCount = $(selector + ' p').length;
    if (pCount <= 1) {
        return;
    }

    $(selector + ' p').each(function () {
        if (counter !== 0) {
            $(this).toggle();
        }
        counter = counter + 1;
    });

    selectorExists = $('.show-more-details').is('*');

    if (selectorExists === false) {
        $(selector).after(
            "<a aria-expanded='false' class='show-more-details' href='#show-" +
                selector.substring(1) +
                "'>More Details</a>",
        );
    }

    if (!selectorExists) {
        $('.show-more-details').click(function () {
            $(this).toggleClass('active');
            if (isShown === true) {
                isShown = false;
                $(this).html('More Details');
                $(this).attr('aria-expanded', false);
            } else {
                isShown = true;
                $(this).html('Hide Details');
                $(this).attr('aria-expanded', true);
            }
            singleProductHelpers.toggleDescription(selector, isShown);
        });
    }
};

/**
 * This will hide all elements with the given class selector,
 * and will then show the element with the photoSelector.  The
 * photoSelector is used in conjunction with an image's data-index
 * attribute
 */
singleProductHelpers.togglePhoto = function (classSelector, photoSelector) {
    console.log('singleProductHelpers', 'togglePhoto');

    if (classSelector === null || photoSelector === null) {
        return;
    }

    $(classSelector).addClass('no-display');
    $('img[data-index=' + photoSelector + ']').removeClass('no-display');
};

/**
 * If zoom is turned on, this will essentially
 * turn it off, and clean up DOM elements
 * that zoom leaves behind
 */
singleProductHelpers.unbindZoom = function () {
    console.log('singleProductHelpers', 'unbindZoom');

    $('.product-photos').unbind();
    $('.zoomImg').remove();
    $('.product-photos').css('position', 'inherit');
    $('.zoom').html('Zoom');
    singleProductHelpers.isZoomOn = false;
};

/**
 * Photo iterator helper, moves us forward to the next photo
 */
singleProductHelpers.nextPhoto = function () {
    console.log('singleProductHelpers', 'nextPhoto');

    var iter_pos, iter_count;
    iter_pos = parseInt($('#photo-iter-pos').html(), 10) - 1;
    iter_count = parseInt($('#photo-iter-count').html(), 10) - 1;

    $('.product-photo:not(.no-display)').addClass('no-display');

    if (singleProductHelpers.isZoomOn === true) {
        singleProductHelpers.unbindZoom();
    }

    iter_pos = iter_pos + 1;
    if (iter_pos > iter_count) {
        iter_pos = 0;
    }

    $('#photo-iter-pos').html(iter_pos + 1);
    $('.product-photo:eq(' + iter_pos + ')').removeClass('no-display');
};

/**
 * Photo iterator helper, moves us to the previous photo
 */
singleProductHelpers.previousPhoto = function () {
    console.log('singleProductHelpers', 'previousPhoto');

    var iter_pos, iter_count;
    iter_pos = parseInt($('#photo-iter-pos').html(), 10) - 1;
    iter_count = parseInt($('#photo-iter-count').html(), 10) - 1;

    $('.product-photo:not(.no-display)').addClass('no-display');

    if (singleProductHelpers.isZoomOn === true) {
        singleProductHelpers.unbindZoom();
    }

    iter_pos = iter_pos - 1;
    if (iter_pos < 0) {
        iter_pos = iter_count;
    }

    $('#photo-iter-pos').html(iter_pos + 1);
    $('.product-photo:eq(' + iter_pos + ')').removeClass('no-display');
};

/* indexOf implementation for IE8, based on Mozilla's implementation. */
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement /*, fromIndex */) {
        'use strict';
        if (this == null) {
            throw new TypeError();
        }

        var t = Object(this);
        var len = t.length >>> 0;
        if (len === 0) {
            return -1;
        }

        var n = 0;
        if (arguments.length > 1) {
            n = Number(arguments[1]);
            if (n != n) {
                // shortcut for verifying if it's NaN
                n = 0;
            } else if (n != 0 && n != Infinity && n != -Infinity) {
                n = (n > 0 || -1) * Math.floor(Math.abs(n));
            }
        }

        if (n >= len) {
            return -1;
        }

        var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
        for (; k < len; k++) {
            if (k in t && t[k] === searchElement) {
                return k;
            }
        }

        return -1;
    };
}

/* Add String.contains() as neccessary. */
if (!('contains' in String.prototype))
    String.prototype.contains = function (str, startIndex) {
        return -1 !== this.indexOf(str, startIndex);
    };

/* Namespace declaration. */
var productHelpers = {};

/**
 * Using the provided selector this will
 * set a drop down, with a default option of
 * quantity (value = 1), and then fill from 1 to
 * quantity. Selector should include the octothorpe,
 * or the '.'
 */
productHelpers.changeQuantityDropdown = function (quantity, selector, currVal) {
    console.log('productHelpers', 'changeQuantityDropdown');

    if (selector === null || quantity === null) {
        quantity = 0;
    }

    if (quantity > 4) {
        quantity = 4;
    }

    var i = 1;

    $(selector).empty();
    if (currVal === null) {
        $(selector).append('<option value="1" selected=true>Quantity</option>');
    } else {
        $(selector).append('<option value="1">Quantity</option>');
    }

    for (i; i <= quantity; i++) {
        if (i === currVal) {
            $(selector).append('<option value="' + i + '" selected=true>' + i + '</option>');
        } else {
            $(selector).append('<option value="' + i + '">' + i + '</option>');
        }
    }
};

(function ($) {
    'use strict';

    var counter = 0,
        selectorExists = false;

    /**
     * Now we can manipulate the DOM elements
     */
    $(document).ready(function () {
        $('.navbar .nav .main').each(function (index, element) {
            var hammertime = new Hammer(element);
            hammertime.on('doubletap', function (el) {
                window.location.href = $(element).attr('href');
            });
        });

        // For shop pagination to work properly we have to use a certain trick
        if (window.location.hash) {
            $('#prod-next').attr('href', $('#prod-next').attr('href') + window.location.hash);
            $('#prod-previous').attr('href', $('#prod-previous').attr('href') + window.location.hash);
        }

        // Search menu expands on mobile
        $('#mobile-search-icon').click(function () {
            $('.mobile-search').toggle();
        });

        // Addresses viewport repositioning on iOS devices
        if ('ontouchstart' in document.documentElement) {
            $('.mobile-search, .search, .newsletter-signup').click(function () {
                $('.navbar-fixed-top').addClass('fixfixed');
            });
        }

        var menuOpen = function () {
            $('.search-bar').hide();
            $('.nav > li > ul').hide();
            $('.nav > li > .featured-image').hide();
            var $ul = $(this).find('> ul');
            $ul.css('display', 'flex');
            $(this).find('> a').attr('aria-expanded', true);
            $(this).find('> ul').attr('aria-hidden', false);

            if (!$.isMobile.matches) {
                $ul.show();
                $ul.css('display', 'flex');
            } else {
                $ul.on('shown.bs.collapse', function () {
                    $ul.css('display', 'flex');
                });
            }

            var $container = $ul.closest('.container');
            var width = $container.outerWidth() - ($ul.offset().left - $container.offset().left);
            var liWidths = 0;
            $ul.find('> li').each(function () {
                liWidths += $(this).outerWidth(true) + 1; // The one helps not round pixels down
            });
            $ul.css('width', width + 'px');
            var height = $ul.offset().top + $ul.outerHeight() - $container.offset().top;
            $('.navbar-backdrop').css('height', height + 'px');
            $('.navbar-backdrop').show();
        };

        var menuClose = function (ev) {
            // Correct the "this" problem setTimeout has
            // @see https://developer.mozilla.org/en-US/docs/DOM/window.setTimeout
            var $ul = $(this).find('> ul');

            $ul.css('display', 'none');
            $('.nav > li > a').attr('aria-expanded', false);
            $('.nav > li > ul').attr('aria-hidden', true);

            if (!$.isMobile.matches) {
                singleProductHelpers.shopTimeout = setTimeout(function () {
                    $ul.hide();
                }, 150);
            } else {
                $ul.on('hidden.bs.collapse', function () {
                    $ul.css('display', 'none');
                });
            }

            $('.navbar-backdrop').hide();
        };

        var $li = $('.navbar .nav > li');
        var $liA = $('.navbar .nav > li > a');
        $li.mouseenter(menuOpen).mouseleave(menuClose);
        $li.click(menuOpen).mouseleave(menuClose);
        $liA.keydown(function (event) {
            var keyCode = event.keyCode ? event.keyCode : event.which;
            if (keyCode == 40) {
                $(this).parent('li').trigger('mouseenter');
            }

            if (keyCode == 38) {
                $li.trigger('mouseleave');
            }
        });

        $(document).on('touchstart', function (e) {
            var touchedOutsideNavbar = !$(e.target).closest('.navbar').length;
            if (touchedOutsideNavbar) {
                $li.each(function () {
                    $(this).trigger('mouseleave');
                });
            }
        });

        // Share button
        $('.share').click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            $.modal.close();

            if (singleProductHelpers.isZoomOn) {
                singleProductHelpers.unbindZoom();
            }

            var thisAttr = $(this).attr('href');
            $(thisAttr).modal({
                close: true,
                closeClass: 'close',
                onClose: function (dialog) {
                    $.modal.close();

                    if (navigator.userAgent.indexOf('Firefox') != -1 || navigator.userAgent.indexOf('MSIE 9.0') != -1) {
                        $(thisAttr + ' .fb-like span').height(30);
                        $(thisAttr + ' .fb-like span iframe').height(30);
                    }
                },
            });
        });

        $('.collection-sidebar a').each(function () {
            if ($(this).attr('href') === window.location.pathname) {
                $(this).addClass('italic');
            }
        });

        // Zoom functionality
        if ('ontouchstart' in document.documentElement) {
            // Disables zoom on touch devices
            $('.zoom').hide();
        }

        $('.zoom').click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            $.modal.close();
            if (singleProductHelpers.isZoomOn === false) {
                var x = $('.product-photo:not(.no-display)').attr('src');
                $('.product-photos').zoom({ url: x });
                $('.zoom').html('Turn Zoom Off');
                singleProductHelpers.isZoomOn = true;
            } else {
                singleProductHelpers.unbindZoom();
            }
        });

        // Since zoom messes the nav functionality up, this disables zoom if it's on
        $('#nav').hover(function () {
            if (singleProductHelpers.isZoomOn === true) {
                singleProductHelpers.unbindZoom();
            }
        });

        //hide links, etc.
        $('ul.collections-list li').hover(
            function () {
                $(this).find('div.details p').show();
            },
            function () {
                $(this).find('div.details p').hide();
            },
        );

        // Fixes product details paragraph height
        $('.product-details p').each(function () {
            var currHeight = parseInt($(this).height(), 10);
            $(this).attr('aria-expanded', false);
            if (currHeight > singleProductHelpers.height) {
                singleProductHelpers.height = currHeight;
                $(this).attr('aria-expanded', true);
            }
        });
        $('.product-details').height(singleProductHelpers.height);

        // Trim the description on a product page
        singleProductHelpers.toggleDescription('#prod-trim-desc');

        // Other image views...
        $('#other-views img, #other-views-mobile img').click(function (e) {
            e.preventDefault();

            if (singleProductHelpers.isZoomOn) {
                singleProductHelpers.unbindZoom();
            }

            singleProductHelpers.togglePhoto('.product-photo', $(this).data('ptr'));
        });
    });

    $(window).load(function () {
        var marginTopForProductImage;

        /*
        // Fixes product li img height, again needed to ensure proper layout
        $('.prod-li-img').each(function () {
            var currHeight = parseInt($(this).height());
            if (currHeight > singleProductHelpers.prodImgHeight) {
                singleProductHelpers.prodImgHeight = currHeight;
            }
        });
        $('.prod-li-img').height(singleProductHelpers.prodImgHeight);
        */

        // Fixes product details paragraph height
        $('.product-details p').each(function () {
            var currHeight = parseInt($(this).height(), 10);
            if (currHeight > singleProductHelpers.height) {
                singleProductHelpers.height = currHeight;
            }
        });
        $('.product-details').height(singleProductHelpers.height);
        
        /*
        // Fixes product li height, again needed to ensure proper layout
        $('li.product-li').each(function () {
            var currHeight = parseInt($(this).height(), 10);
            if (currHeight > singleProductHelpers.productHeight) {
                singleProductHelpers.productHeight = currHeight;
            }
        });
        $('li.product-li').height(singleProductHelpers.productHeight);
        */

        // Now let's vertically single page images
        $('.product-photo').each(function () {
            var childHeight;
            $(this).css({
                // Optional if #myDiv is already absolute
                visibility: 'hidden',
                display: 'block',
            });

            childHeight = $(this).height();
            marginTopForProductImage = $('.seven-eighths').height() / 2 - childHeight / 2;

            $(this).css({
                position: '', // Again optional if #myDiv is already absolute
                visibility: '',
                display: '',
            });

            // Fix it from getting too big
            if (marginTopForProductImage > 150) {
                marginTopForProductImage = 150;
            }
        });

        $('.product-photo').first().removeClass('no-display');
    });
})(jQuery);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);
$(document).ready(function () {
    var drawer = $('.localization-drawer');
    var drawerOverlay = $('.localization-drawer-overlay');
    var isDrawerShowing = false;
    
    $('[data-localization-toggle]').on('click', function (event) {
        event.preventDefault();                
        isDrawerShowing = !isDrawerShowing;

        if (isDrawerShowing) {
            drawer.addClass('open');
            drawerOverlay.addClass('open');
            $('.localization-drawer__item').first().children('a').focus();
        } else {
            drawer.removeClass('open');
            drawerOverlay.removeClass('open');
        }
    });

    $('[data-localization-toggle]').keydown(function (event) {
        if (event.keyCode == 13) {
            drawer.removeClass('open');
            drawerOverlay.removeClass('open');
        }
    });
    
    $('.localization-drawer a').on('click', function(event) {
        event.preventDefault();    
        drawer.find('input[name="country_code"]').val($(this).data('value'));
        console.log($(this).data('value'));        
        drawer.find('form').submit();
    });
});
// Appears to be old Constant Contact integration
/*
var localizedErrMap = {};
localizedErrMap['required'] = 'This field is required.';
localizedErrMap['ca'] = 'An unexpected error occurred while attempting to send email.';
localizedErrMap['email'] = 'Please enter your email address in name@email.com format.';
localizedErrMap['birthday'] = 'Please enter birthday in MM/DD format.';
localizedErrMap['anniversary'] = 'Please enter anniversary in MM/DD/YYYY format.';
localizedErrMap['custom_date'] = 'Please enter this date in MM/DD/YYYY format.';
localizedErrMap['list'] = 'Please select at least one email list.';
localizedErrMap['generic'] = 'This field is invalid.';
localizedErrMap['shared'] = 'Sorry, we could not complete your sign-up. Please contact us to resolve this.';
localizedErrMap['state_mismatch'] = 'Mismatched State/Province and Country.';
localizedErrMap['state_province'] = 'Select a state/province';
localizedErrMap['selectcountry'] = 'Select a country';
var postURL = 'https://visitor2.constantcontact.com/api/signup';
*/

$(document).ready(function () {
    //Submit button from 1st visitor popup Email
    var email;
    var mobileTrimmed;
    $('#btnSubmitEmail').click(function (e) {
        e.preventDefault(); //STOP default action

        email = $('#emailInput').val();
        if (!validateEmail(email)) {
            alert('Please enter valid email');
            $('#loaderDiv').attr('style', 'display:none');

            return false;
        }
        $('#loaderDiv').attr('style', 'display:block');
        setTimeout(() => {
            $('#constantContact').attr('style', 'display:none');
            $('#constantContactMobile').attr('style', 'display:block');
        }, 1000);
    });

    //Submit button from 1st visitor popup Mobile
    $('#btnSubmitMobile').click(function (e) {
        e.preventDefault(); //STOP default action
        $('#loaderDiv').attr('style', 'display:block');
        var mobile = $('#mobileInput').val();
        mobileTrimmed = mobile.replace(/\D/g, '');

        if (mobileTrimmed.length !== 10) {
            alert('Please enter valid phone number');
            $('#loaderDiv').attr('style', 'display:none');

            return false;
        }

        var urlToGet = `https://mobile.gapinternational.com/ARAKSAPI/api/Newsletter/Signup?phone=${mobileTrimmed}&source=popup&email=${email}`;
        var request = new XMLHttpRequest();
        var params = 'action=something';

        request.open('GET', urlToGet, true);
        request.onreadystatechange = function () {
            if (request.readyState == 4) {
                // alert(request.responseText);
                if (request.responseText == '"already subscribed"') {
                    var display = $('#constantContactMobile').css('display');
                    if (display != 'none') {
                        $('#constantContactMobile').attr('style', 'display:none');
                    }
                    var displayF = $('#flatteredDiv').css('display');
                    if (displayF == 'none') {
                        $('#flatteredDiv').attr('style', 'display:block');
                    }
                } else if (request.responseText == '"error"') {
                    alert('Please enter a valid mobile number');
                    $('#loaderDiv').attr('style', 'display:none');
                    return false;
                } else {
                    var d2 = new Date();
                    $.cookie('registered', d2, { expires: 1000, path: '/' });
                    var display = $('#constantContactMobile').css('display');
                    if (display != 'none') {
                        $('#constantContactMobile').attr('style', 'display:none');
                    }
                    var displayTY = $('#BottomEmailSubscriber').css('display');
                    if (displayTY == 'none') {
                        $('#BottomEmailSubscriber').attr('style', 'display:block');
                    }
                    var displayF = $('#flatteredDiv').css('display');
                    if (displayF != 'none') {
                        $('#flatteredDiv').attr('style', 'display:none');
                    }
                }
                $('#loaderDiv').attr('style', 'display:none');
            }
        };
        request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        request.send(params);
    });

    //Desktop layout bottom button
    $('#btnSubmitBot1').click(function (e) {
        var email = $('#newsletterDesk #deskemail').val();
        if (!validateEmail(email)) {
            alert('Please enter valid email');
            return false;
        }
        var urlToGet =
            'https://mobile.gapinternational.com/ARAKSAPI/api/Newsletter/Signup?email=' + email + '&source=footer';
        var request = new XMLHttpRequest();
        var params = 'action=something';
        request.open('GET', urlToGet, true);
        request.onreadystatechange = function () {
            if (request.readyState == 4) {
                if (request.responseText == '"already subscribed"') {
                    var display = $('#constantContact').css('display');
                    if (display != 'none') {
                        $('#constantContact').attr('style', 'display:none');
                    }
                    var displayTY = $('#contantContactTY').css('display');
                    if (displayTY != 'none') {
                        $('#contantContactTY').attr('style', 'display:none');
                    }
                    var displayF = $('#flatteredDiv').css('display');
                    if (displayF == 'none') {
                        $('#flatteredDiv').attr('style', 'display:block');
                    }
                    $('#fvButton').trigger('click');
                } else if (request.responseText == '"error"') {
                    alert('Please enter valid email');
                    return false;
                } else {
                    var display = $('#constantContact').css('display');
                    if (display != 'none') {
                        $('#constantContact').attr('style', 'display:none');
                    }
                    var displayTY = $('#BottomEmailSubscriber').css('display');
                    if (displayTY == 'none') {
                        $('#BottomEmailSubscriber').attr('style', 'display:block');
                    }
                    var displayF = $('#flatteredDiv').css('display');
                    if (displayF != 'none') {
                        $('#flatteredDiv').attr('style', 'display:none');
                    }
                    $('#fvButton').trigger('click');
                }
            }
        };
        request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        request.send(params);
        e.preventDefault(); //STOP default action
    });

    function validateEmail(email) {
        var re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    const footerNav = document.querySelectorAll('.footer-nav__col-heading');

    footerNav.forEach(function (nav) {
        nav.addEventListener('click', function () {
            footerNav.forEach(function (nav) {
                nav.parentNode.classList.remove('active');
            });

            this.parentNode.classList.add('active');
        });
    });

    $('#mobileInput').inputmask({ mask: '(999)-999-9999' });
});

$(document).ready(function () {
    $('.navbar-nav a.main').each(function () {
        var href = $(this).attr('href');
        var url = window.location.pathname.split('-')[0];
        if (href && href.indexOf(url) >= 0 && url != '/') {
            $(this).addClass('current');
        }
    });
    
    $('#q').keypress(function (event) {
        var keycode = event.keyCode ? event.keyCode : event.which;
        if (keycode == '13') {
            $('#search').focus().click();
        }
    });
    
    var bindEscapeKey = function (namespace, callback) {
        var escapeKey = 27;

        $(document).on('keyup.' + namespace, function (e) {
            if (e.keyCode == escapeKey) {
                callback();
            }
        });
    };

    var unbindEscapeKey = function (namespace) {
        $(document).off('keyup.' + namespace);
    };

    bindEscapeKey('search-bar', closeSearchBar);        

    // Close search-bar, updated aria-expanded on search-link button and
    // bring focus back to the search-link button when search-bar closes.
    function closeSearchBar() {
        var searchBtn = $('.search-link');
        $('.search-bar').toggle(false);
        searchBtn.attr('aria-expanded', 'false');
        searchBtn.focus();
    }

    $('.search-link').on('click', function (e) {
        e.preventDefault();
        this.setAttribute('aria-expanded', 'true');
        $('.search-bar').toggle();
        $('.search-bar input[name=q]').focus();
    });

    //adding close image-CDP 6/23/2020
    $('#search-close').on('click', function (e) {
        e.preventDefault();
        closeSearchBar();
    });

    //adding search for mobile- CDP 6/23/2020
    $('.search-mobile-link').click(function () {
        $('#mobileButtonMenu').click();
    });

    // Add focusout and focusin events to the search-bar. This will close
    // the search-bar with a setTimeout if any of the inputs in search-bar
    // looses focus.
    var searchBarTimeout = null;
    $('.search-bar').on('focusin', function () {
        if (searchBarTimeout != null) {
            clearTimeout(searchBarTimeout);
        }
    });

    $('.search-bar').on('focusout', function () {
        searchBarTimeout = setTimeout(function () {
            closeSearchBar();
        }, 1000);
    });
});

$(document).ready(function () {
    var backwardOneLevel = function () {
        var isSecondLevel = $('.mobile-navigation').hasClass('second-level');
        var isThirdLevel = $('.mobile-navigation').hasClass('third-level');

        if (isSecondLevel) {
            $('.mobile-navigation').removeClass('second-level').addClass('first-level');
        }

        if (isThirdLevel) {
            $('.mobile-navigation').removeClass('third-level').addClass('second-level');
        }
    };

    var isMenuShowing = false;
    $('[data-menu-toggle]').on('click', function () {
        isMenuShowing = !isMenuShowing;

        if (isMenuShowing) {
            $('.mobile-navigation').addClass('open');
            $('.mobile-navigation-overlay').addClass('open');
            $('.mobile-navigation__parent').first().children('a').focus();
        } else {
            $('.mobile-navigation').removeClass('open');
            $('.mobile-navigation-overlay').removeClass('open');
        }
    });

    $('[data-menu-toggle]').keydown(function (event) {
        if (event.keyCode == 13) {
            $('.mobile-navigation').removeClass('open');
            $('.mobile-navigation-overlay').removeClass('open');
        }
    });

    $('.mobile-navigation__trigger').on('click', function (e) {
        if ($(this).hasClass('prevent')) {
            return;
        }
    
        e.preventDefault();
        
        var trigger = this;
        var triggerParent = $(this).parent();
        console.log('Mobile nav trigger', trigger, triggerParent[0]);
        
        $('.mobile-navigation ul > li').each(function (index, element) {
            if (element !== triggerParent[0]) { 
                $(element).removeClass('active');
            }
        });
        
        if ($(trigger).parent().hasClass('active')) {
            $(trigger).parent().removeClass('active');
            
            return;
        } 
        
        $(trigger).parent().addClass('active');
    });

    $('.mobile-navigation [data-menu-back]').on('click', function (e) {
        e.preventDefault();
        backwardOneLevel();
    });

    $(document).keydown(function (event) {
        var keyCode = event.keyCode ? event.keyCode : event.which;
        if (keyCode == 27 && isMenuShowing) {
            $('.mobile-navigation').removeClass('open');
            $('.mobile-navigation-overlay').removeClass('open');
        }
        isMenuShowing = false;
    });
});

var productJson = {};

var handleVariantQuantities = function (variant) {
    console.log('handleVariantQuantities', variant);
        
    var quantity = 0;
    if (variant && $('select[name="id"] :selected').length > 0) {
        quantity = $('select[name="id"] :selected').data('quantity');
    }
    
    $('[data-inventory-quantities]')
        .each(function () {
            var $this = $(this);
            var $show = $this.find('[data-inventory-quantity=' + quantity + ']');

            if (!$show.length) {
                $show = $this.find('> [data-inventory-quantity=default]');
            }

            $this.find('> [data-inventory-quantity]').hide();
            $show.show();
        })
        .show();
};

function updateColors(variant) {
    console.log('updateColors', variant);

    var selectedVariant = variant.title;
    var currentSwatch = document.querySelector('.color.options li.selected');

    if (currentSwatch) {
        currentSwatch.classList.remove('soldout');
        if (!variant.available) {
            currentSwatch.classList.add('soldout');
        }
    }

    document.querySelectorAll('.color.options li:not(.selected)').forEach(function (element) {
        element.classList.remove('soldout');

        var availableVariantsData = element.dataset.available;
        var alternativeProductId = element.dataset.id;
        var alternativeProductUrl = element.dataset.url;

        // Unescape any characters modified by Shopify escape filter
        var parser = new DOMParser().parseFromString(availableVariantsData, 'text/html');
        var availableVariants = parser.documentElement.textContent;

        if (availableVariants.indexOf(selectedVariant) === -1) {
            //console.log('Color not available');
            element.classList.add('soldout');
        }

        // Change swatch URL to match selected options
        if (typeof variantTitles[alternativeProductId] !== 'undefined') {
            var variantIndex = variantTitles[alternativeProductId].findIndex(function (element, index, array) {
                return element == selectedVariant;
            });

            if (variantIndex !== -1 && typeof variantIds[alternativeProductId][variantIndex] !== 'undefined') {
                //console.log(alternativeProductId, alternativeProductUrl, variantIndex, variantIds[alternativeProductId][variantIndex]);

                var link = element.querySelector('a');
                link.href = alternativeProductUrl + '?variant=' + variantIds[alternativeProductId][variantIndex];
            } else {
                //console.log('No matching variant found', selectedVariant, variantIndex);

                var link = element.querySelector('a');
                link.href = alternativeProductUrl;
            }
        }
    });
}

var selectCallback = function (variant, selector) {
    console.log('selectCallback', variant, selector);

    if (variant) {
        if (variant.available) {
            // Selected a valid variant that is available.
            $('.btn-purchase').each(function () {
                $(this).removeClass('disabled').removeAttr('disabled').html('Add to Cart');
                $(this).attr('data-cart-add', variant.id);
            });
            handleVariantQuantities(variant);
        } else {
            // Variant is sold out.
            $('.btn-purchase').each(function () {
                $(this).html('Sold Out').addClass('disabled').attr('disabled', 'disabled');
            });
            handleVariantQuantities(null);
        }
        // Whether the variant is in stock or not, we can update the price and compare at price.
        if (variant.compare_at_price > variant.price) {
            $('.price-field').each(function () {
                $(this).html(
                    '<s class="product-compare-price">' +
                        Shopify.formatMoney(variant.compare_at_price, '') +
                        '</s> &nbsp;' +
                        '<span class="product-price on-sale">' +
                        Shopify.formatMoney(variant.price, '') +
                        '</span>',
                );
            });
        } else {
            $('.price-field').each(function () {
                $(this).html('<span class="product-price">' + Shopify.formatMoney(variant.price, '') + '</span>');
            });
        }

        updateColors(variant);
    } else {
        // Variant doesn't exist.
        $('.btn-purchase').each(function () {
            $(this).val('Unavailable').addClass('disabled').attr('disabled', 'disabled');
        });
    }
};

function decorateSelector(product, index, name) {
    console.log('decorateSelector', index, name);

    var $option = $('[data-option=option' + index + ']');
    var $blocks = $(
        '<div class="option-wrapper">' +
            '<div class="product-option-label">' +
            name +
            '</div>' +
            '<ul class="option-blocks option-blocks-' +
            name.toLowerCase() +
            '"></ul>' +
            '</div>',
    );

    $option.closest('.selector-wrapper').hide();

    $option.find('option').each(function () {
        var $this = $(this);
        var $block = $('<li/>');
        $block.text($this.text());
        product.variants.forEach((variant) => {
            $block.attr('tabindex', 0);
            if (variant.title === $this.text() && variant.available == false) {
                $block.addClass('outOfStock');
            }
        });
        $block.data('value', $this.attr('value'));

        $block.click(function () {
            var $this = $(this);
            $option.val($this.data('value'));
            $option.trigger('change');
            $blocks.find('li').removeClass('active');
            $this.addClass('active');
            const urlParams = new URLSearchParams(window.location.search);
            const paramVariant = urlParams.get('variant');
            $('#variant-id').html(paramVariant);
        });

        $block.keypress(function () {
            if (event.which == 13) {
                var $this = $(this);
                $option.val($this.data('value'));
                $option.trigger('change');
                $blocks.find('li').removeClass('active');
                $this.addClass('active');
                const urlParams = new URLSearchParams(window.location.search);
                const paramVariant = urlParams.get('variant');
                $('#variant-id').html(paramVariant);
            }
        });

        $blocks.find('ul').append($block);
    });

    // When variant selected trigger click on size option
    if ($('.btn-purchase').attr('data-cart-add').length > 0) {
        var option = null;

        $blocks.find('li').each(function () {
            if ($(this).data('value') == $option.val()) {
                option = $(this);
            }
        });

        if (option) {
            console.log('Trigger add to cart button click');
            option.trigger('click');
        }
    }

    $option.closest('.selector-wrapper').after($blocks);
}

function initMultiOptions() {
    /*
     * Visually disable unavailable options when
     * product has two or three options
     *
     * Single options are handled via Liquid code
     * in sections/product-main.liquid
     *
     * Referenced parts of the following examples:
     * @link https://help.shopify.com/en/manual/online-store/themes/os/customize/hide-sold-out-variants
     * @link https://gist.github.com/carolineschnapp/1083007
     */

    var option1 = $('select[id=product-select-option-0]');
    var option2 = $('select[id=product-select-option-1]');
    var option3 = $('select[id=product-select-option-2]');

    if (typeof productJson !== 'object') {
        return;
    }

    var product = productJson;
    console.log('initMultiOptions');

    if (product.available === false) {
        console.log('Product unavailable', product.available);
        disableAllMultiOptions();
        return;
    }

    var mutationCallback = function (mutationList, observer) {
        var optionTitle = [];

        if (option1.length) {
            optionTitle.push(option1.val());
        }

        if (option2.length) {
            optionTitle.push(option2.val());
        }

        if (option3.length) {
            optionTitle.push(option3.val());
        }

        console.log('Selected option', optionTitle.join(' / '));

        var currentVariant = product.variants.filter(function (variant) {
            return variant.title == optionTitle.join(' / ');
        });

        console.log('Current variant', currentVariant);

        if (currentVariant.length) {
            resetMultiOptions();

            if (option2.length) {
                console.log('Updating option 2');
                var unavailableOptions = product.variants.filter(function (variant) {
                    return variant.option1 == option1.val() && variant.available == false;
                });

                disableMultiOptions(unavailableOptions, 'option2');
            }

            if (option3.length) {
                console.log('Updating option 3');
                var unavailableOptions = product.variants.filter(function (variant) {
                    return (
                        variant.option1 == option1.val() &&
                        variant.option2 == option2.val() &&
                        variant.available == false
                    );
                });

                disableMultiOptions(unavailableOptions, 'option3');
            }
        }

        if (observer !== null) {
            if (option1.length) {
                console.log('Updating option 1 blocks');
                $('.select-options li').each(function () {
                    if ($(this).text() == option1.val()) {
                        $(this).addClass('active');
                    }
                });
            }

            if (option2.length) {
                console.log('Updating option 2 blocks');
                $('.select-options li').each(function () {
                    if ($(this).text() == option2.val()) {
                        $(this).addClass('active');
                    }
                });
            }

            if (option3.length) {
                console.log('Updating option 3 blocks');
                $('.select-options li').each(function () {
                    if ($(this).text() == option3.val()) {
                        $(this).addClass('active');
                    }
                });
            }
        }
    };

    if (product.options.length > 1) {
        var addToCartForm = $('form[action*="/cart/add"]');
        var observer = new MutationObserver(mutationCallback);

        var urlParams = new URLSearchParams(window.location.search);
        var paramVariant = urlParams.get('variant');
        if (paramVariant !== null) {
            mutationCallback(null, null);
        }

        if (window.MutationObserver && addToCartForm.length) {
            var config = { childList: true, subtree: true };

            if (typeof observer === 'object' && typeof observer.disconnect === 'function') {
                observer.disconnect();
            }

            observer.observe(addToCartForm.get(0), config);
            console.log('MutationObserver init');
        }
    }
}

function resetMultiOptions() {
    console.log('Reset options');

    $('.select-options li').removeClass('outOfStock');
}

function disableMultiOptions(variants, name) {
    console.log('Disable options', variants);

    variants.forEach(function (variant) {
        $('.select-options li').each(function () {
            console.log('Disable variant name', variant[name]);
            if ($(this).text() == variant[name]) {
                $(this).addClass('outOfStock');
            }
        });
    });
}

function disableAllMultiOptions() {
    console.log('Disable all options');

    $('.select-options li').addClass('outOfStock');
}

$(document).ready(function () {
    // Override Shopify OptionSelectors to prevent selected variant by default
    Shopify.OptionSelectors.prototype.initDropdown = function () {
        var t = {
            initialLoad: !0,
        };
        console.log('Custom selectVariantFromDropdown', t, this.selectVariantFromDropdown(t));
        if (!this.selectVariantFromDropdown(t)) {
            var e = this;
            setTimeout(function () {
                //e.selectVariantFromParams(t) || e.fireOnChangeForFirstDropdown.call(e, t)
                e.selectVariantFromParams(t);
            });
        }
    };

    // Disable add to cart button when no variant selected on load
    if ($('.btn-purchase').length > 0 && $('.btn-purchase').attr('data-cart-add').length == 0) {
        $('.btn-purchase').each(function () {
            $(this).addClass('disabled');
        });
    }

    // Show sliding cart
    $('.btn-purchase').each(function () {
        $(this).click(function () {
            $('.sliding-cart').addClass('active');
            $('body').addClass('sliding-cart-displayed');
        });
    });

    // Parse product JSON
    if ($('[data-product-json]').length > 0) {
        productJson = JSON.parse($('[data-product-json]').html());
        console.log('productJson', productJson);
    }

    if ($('#product-select').length > 0) {
        console.log('Init option selectors');

        // Init option selectors
        new Shopify.OptionSelectors('product-select', {
            product: productJson,
            onVariantSelected: selectCallback,
            enableHistoryState: true,
        });

        // Decorate selectors with option blocks
        productJson.options.forEach((option, index) => {
            decorateSelector(productJson, index + 1, option);
        });

        // Enable multi options
        if (productJson.options.length > 1) {
            initMultiOptions();
        }

        $('.select-options').addClass('active');
    }

    /*
    This is sort of a hack, but if this is a product,
    then we should display size guide if it exists. This also
    will scan for a single variant, and handle that situation.
    */

    // Size charts
    var coll = document.getElementsByClassName('collapsible');
    var i;

    for (i = 0; i < coll.length; i++) {
        coll[i].addEventListener('click', function () {
            this.classList.toggle('active');
            $(this).attr('aria-expanded', false);
            //var content = this.nextElementSibling;
            var content = document.querySelector(this.dataset.content);
            if (content) {
                if (content.style.maxHeight) {
                    content.style.maxHeight = null;
                    $(content).attr('aria-expanded', false);
                    $(this).attr('aria-expanded', false);
                    $(content).attr('aria-hidden', true);
                    $(content).attr('tabindex', -1);
                } else {
                    content.style.maxHeight = content.scrollHeight + 'px';
                    $(content).attr('aria-expanded', true);
                    $(this).attr('aria-expanded', true);
                    $(content).attr('aria-hidden', false);
                    $(content).attr('tabindex', 0);
                }
            }
        });
    }

    /*
    //if (typeof Shopify.resizeImage === 'undefined') {
      //document.write({{ "api.jquery.js" | shopify_asset_url | script_tag | json }});
    //}
    */

    /*
    // Modal show image
    function showImage(imageUrl) {
      var modalImg = document.getElementById('img01');
      var modal = document.getElementById('myModal');
    
      modalImg.src = imageUrl;
      modal.style.display = 'block';
      var el = document.querySelector('div.pinch-zoom');
      new PinchZoom(el, {});
      $('#btnModal').click();
    }
    */

    // Quantity controls
    var quantityInput = $('input[name="quantity"]');
    var quantityVal = quantityInput.val();
    var quantityMax = quantityInput.attr('max');
    var quantityMin = quantityInput.attr('min');

    var quantityChange = function (quantityVal) {
        $('.btn-purchase').each(function () {
            $(this).attr('data-cart-quantity', quantityVal);
        });
    };

    $('.quantity-add').click(function () {
        quantityVal++;

        if ($('.btn-purchase:disabled').length > 0) {
            return;
        }

        if (quantityVal <= quantityMax) {
            quantityInput.val(quantityVal);
            quantityChange(quantityVal);
        } else {
            quantityInput.val(quantityMax);
            quantityVal = quantityMax;
            quantityChange(quantityVal);
        }
    });

    $('.quantity-add').keypress(function () {
        quantityVal++;

        if ($('.btn-purchase:disabled').length > 0) {
            return;
        }

        if (quantityVal <= quantityMax) {
            quantityInput.val(quantityVal);
            quantityChange(quantityVal);
        } else {
            quantityInput.val(quantityMax);
            quantityVal = quantityMax;
            quantityChange(quantityVal);
        }
    });

    $('.quantity-subtract').click(function () {
        quantityVal--;

        if ($('.btn-purchase:disabled').length > 0) {
            return;
        }

        if (quantityVal >= quantityMin) {
            quantityInput.val(quantityVal);
            quantityChange(quantityVal);
        } else {
            quantityInput.val(quantityMin);
            quantityVal = quantityMin;
            quantityChange(quantityVal);
        }
    });

    $('.quantity-subtract').keypress(function () {
        if (event.which == 13) {
            quantityVal--;

            if ($('.btn-purchase:disabled').length > 0) {
                return;
            }

            if (quantityVal >= quantityMin) {
                quantityInput.val(quantityVal);
                quantityChange(quantityVal);
            } else {
                quantityInput.val(quantityMin);
                quantityVal = quantityMin;
                quantityChange(quantityVal);
            }
        }
    });

    // Restock email signup
    $('#restockemail').click(() => {
        $('.restock-signup-success').hide();
        $('.restock-signup-error').hide();
    });

    $('#btnSubmitRestock').click(function (e) {
        var key = 'X5ei2T';
        //var key = 'X4j99g';
        var email = $('#restockemail').val();
        //alert(email);
        var variant = $('#variant-id').html();
        if (!validateEmail(email)) {
            alert('Please enter valid email');
            return false;
        }

        // Klaviyo docs reference
        // https://developers.klaviyo.com/en/docs/how-to-enable-back-in-stock-for-custom-catalog-feeds
        var url = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url);

        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        xhr.onreadystatechange = function () {
            if (xhr.status === 200) {
                $('.restock-signup-success').show();
                console.log(xhr.status);
                console.log(xhr.responseText);
            } else {
                $('.restock-signup-success').show();
                //$(".restock-signup-error").show();
                console.log(xhr.status);
                console.log(xhr.responseText);
            }
        };

        var data = `a=${key}&email=${email}&variant=${variant}&platform=shopify`;

        xhr.send(data);
        e.preventDefault();
    });
    
    function validateEmail(email) {
        var re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }    

    var bindEscapeKey = function (namespace, callback) {
        var escapeKey = 27;

        $(document).on('keyup.' + namespace, function (e) {
            if (e.keyCode == escapeKey) {
                callback();
            }
        });
    };

    var unbindEscapeKey = function (namespace) {
        $(document).off('keyup.' + namespace);
    };

    var closeFullscreenImages = function () {
        $('.fullscreen-images').remove();
        $('body').removeClass('noscroll');
        unbindEscapeKey('fullscreen-images');
    };

    $('.product-photos').each(function () {
        var $photos = $(this);

        $photos.find('img').on('click', function (e) {
            console.log('Product photos click', e);
            if (!$('.carousel-indicators').is(':visible')) {
                bindEscapeKey('fullscreen-images', closeFullscreenImages);
                $('body').addClass('noscroll');
                var viewingIndex = $photos.children().index(this);
                var sources = $photos.find('img').map(function () {
                    return $(this).data('full-size-src');
                });
                var render = function () {
                    $previous.show();
                    $next.show();

                    if (viewingIndex == 0) {
                        $previous.hide();
                    }

                    if (viewingIndex == sources.length - 1) {
                        $next.hide();
                    }

                    $innerWrapper.html('<img src="' + sources[viewingIndex] + '" />');
                };
                if (!$('.fullscreen-images').length) {
                    $('body').append('<div class="fullscreen-images"></div>');
                }
                var $fullscreenImages = $('.fullscreen-images');
                var $outerWrapper = $('<div class="outer-wrapper"></div>');
                var $innerWrapper = $('<div class="inner-wrapper"></div>');
                var $previous = $('<div class="previous">Previous</div>');
                var $next = $('<div class="next">Next</div>');
                var $close = $('<div class="close">Close</div>');
                var $loading = $('<div class="loading"></div>');
                $outerWrapper.append($innerWrapper);

                $outerWrapper.append($loading);
                $fullscreenImages.append($previous);
                $fullscreenImages.append($next);
                $fullscreenImages.append($close);
                $fullscreenImages.append($outerWrapper);

                $close.on('click', function () {
                    closeFullscreenImages();
                });

                $next.on('click', function () {
                    if (viewingIndex + 1 < sources.length) {
                        viewingIndex += 1;
                        render();
                    }
                });

                $previous.on('click', function () {
                    if (viewingIndex - 1 >= 0) {
                        viewingIndex -= 1;
                        render();
                    }
                });

                $(document).on('keyup.fullscreen-images', function (e) {
                    var leftArrow = 37;
                    var rightArrow = 39;

                    switch (e.which) {
                        case leftArrow:
                            $previous.trigger('click');
                            break;
                        case rightArrow:
                            $next.trigger('click');
                            break;
                    }
                });

                render();
            }
        });
    });

    var formBottom = 0;

    function onResize() {
        if ($('.shopify-product-form').length > 0) {
            formBottom = $('.shopify-product-form')[0].offsetTop + $('.shopify-product-form')[0].offsetHeight;
        }
    }

    function onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollBottom = scrollTop + window.innerHeight;

        //console.log('onScroll', scrollTop, scrollBottom, formBottom);
        if (scrollTop > formBottom) {
            $('.product-sticky-form').addClass('active');
            //console.log('Show sticky add to cart');
        } else {
            $('.product-sticky-form').removeClass('active');
            //console.log('Hide sticky add to cart');
        }
    }

    // Sticky add to cart
    if ($('.template-product').length > 0) {
        onResize();

        window.addEventListener(
            'resize',
            () => {
                onResize();
                console.log(formBottom);
            },
            false,
        );

        window.addEventListener(
            'scroll',
            () => {
                onScroll();
            },
            false,
        );

        $('.product-sticky-form').on('click', function (event) {
            if ($(this).find('button.disabled').length > 0) {
                event.preventDefault();

                $('.shopify-product-form')[0].scrollIntoView({ behavior: 'smooth' });
            }
        });
    }
});

// Mobile
$.isMobile = window.matchMedia('only screen and (max-width: 760px)');

// Navbar
$(document).ready(function () {
    /*
    //validate newsletter
    $('#contact').validate({
        rules: {
            email: {
                required: true,
                email: true,
            },
        },
        messages: {
            email: 'Please enter a valid email address',
        },
    });
    */

    function addPaddingTop() {
        var navbarHeight = $('.navbar').height();
        $('body').css('paddingTop', navbarHeight);
    }

    addPaddingTop();

    $(window).resize(function () {
        addPaddingTop();
    });
    
    // Recalculate padding top after Global-E activates
    document.addEventListener('glbeParamsSet', function() {
        console.log('glbeParamsSet');
        $(window).resize();
    });
    
    document.addEventListener('glbeParamsReady', function() {
        console.log('glbeParamsReady');
        $(window).resize();
    });    
});

// Cart
//$(document).ready(function () {});
$(document).on('cart.ready', function (event, cart) {
    if ($('.cart-main').length) {
        $('.cart-main').each((index, element) => {
            $(element).attr('data-max', inventoryQuantity[index].inventoryQuantity);
        });
        $('.max-quantity').each((index, element) => {
            $(element).text(inventoryQuantity[index].inventoryQuantity);
        });
    }

    $('a[data-action="quantity-increment"]').each(function (index, element) {
        const max = $(element).prev().attr('data-max');
        const current = $(element).prev().text();

        $(element).click(() => {
            if (current === max) {
                $(element).parent('.quantity').next('.quantity-error').show();
            }
        });
    });

    $('a[data-action="quantity-decrement"]').each(function (index, element) {
        $(element).click(() => {
            $(element).parent('.quantity').next('.quantity-error').hide();
        });
    });
});

// Accordion
$('.accordion-trigger').on('click', function (evt) {
    $(this).parent().toggleClass('accordian-active');
});

// Display size guide.
$('.size-guide-click').click(function (e) {
    var view = new App.Views.Modal({
        selector: '#sizing',
    });

    view.render();
});
